import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import ROUTES from '../constants/routes';

const API = process.env.REACT_APP_API_URL || '';

export default function ProtectedRoute({ children }) {
  const [authed, setAuthed] = useState(null); // null = checking
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('sqetrack_token');
    if (!token) {
      setAuthed(false);
      return;
    }
    fetch(API + '/api/me', {
      headers: { 'Authorization': `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(data => {
        if (data.id) {
          setAuthed(true);
        } else {
          localStorage.removeItem('sqetrack_token');
          setAuthed(false);
        }
      })
      .catch(() => {
        localStorage.removeItem('sqetrack_token');
        setAuthed(false);
      });
  }, []);

  if (authed === null) {
    return <div className="login-wrap"><div className="login-box"><p>Loading</p></div></div>;
  }

  if (!authed) {
    const redirect = location.pathname + location.search;
    return <Navigate to={`${ROUTES.LOGIN}?redirect=${encodeURIComponent(redirect)}`} replace />;
  }

  return children;
}
